































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import PageHead from '@/components/PageHead.vue'
import TinyMCE from '@/components/TinyMCE.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import type { GlobalSettings, NavItem, PageListItem } from '@/interfaces'

@Component({
  components: {
    TinyMCE,
    PageHead,
  },
})

export default class SettingsGlobal extends Vue {
  pageTitle = 'Global Settings'
  callInProgress = false
  settings: GlobalSettings = null
  nav: NavItem[] = null
  pagesList: PageListItem[] = []
  showThankYouMessage = true
  hideAdmin = null
  userType = null
  // gaCode = null
  domainImages = null
  ogImageSelected = false
  thankYouMessageInfo = 'Show a message after the contact form is completed or select the button to direct the visitor to another page'
  autoResponderMessageInfo = 'Content in this box will be sent to the customer when they\'ve submitted the form. Typical content could be an estimated time for you to reply or a holiday notice'
  gaCodeInfo = 'To set up a Googl Analytics 4 property for your website, you need a Google tag ID (which usually starts with "G-")'
  metaTagInfo = 'Google Site Verification. Example Data: googlebec63db66e6a0f0a'
  gtmCodeInfo = 'Googe Tag Manager Code.\nExample Data: GTM-XXXNXXNX'

  mounted() {
    this.fetchGlobalSettings()
  }

  public async fetchGlobalSettings() {
    this.callInProgress = true
    try {
      const globalSettingsResponse = await Api.getGlobalSettings()
      this.settings = globalSettingsResponse.globalSettings
      this.userType = globalSettingsResponse.userType
      this.hideAdmin = this.settings.hideAdmin
      // this.gaCode = this.settings.gaCode
      // this.nav = await Api.getDomainNav()
      this.nav = globalSettingsResponse.domainNav
      this.ogImageSelected = this.settings.ogImage !== ''
      this.getPagesList()
      this.callInProgress = false
      this.fetchDoaminImages()
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  private getPagesList() {
    for (const first_level of this.nav) {
      if ('page_id' in first_level) {
        if (!first_level.hidden) {
          this.pagesList.push({
            page_id: first_level.page_id,
            page_title: first_level.page_title,
          })
        }
      }
      if ('children' in first_level) {
        for (const second_level of first_level.children) {
          if ('page_id' in second_level) {
            if (!second_level.hidden) {
              this.pagesList.push({
                page_id: second_level.page_id,
                page_title: first_level.menu_title + ' - ' + second_level.page_title,
              })
            }
          }
        }
      }
    }
  }

  public async setNameSettings() {
    this.setGlobalSettings({
      businessName: this.settings.businessName,
      heading: this.settings.heading,
    })
  }

  public async setMetaSettings() {
    this.setGlobalSettings({
      metaTitle: this.settings.metaTitle,
      metaDescription: this.settings.metaDescription,
      metaKeywords: this.settings.metaKeywords,
      ogDescription: this.settings.ogDescription,
      ogImage: this.settings.ogImage,
    })
  }

  public async setEmailSettings() {
    this.setGlobalSettings({
      emailThankYouMessage: this.showThankYouMessage ? this.settings.emailThankYouMessage : '',
      emailReturnPage: this.showThankYouMessage ? '' : this.settings.emailReturnPage,
      emailAutoresponder: this.settings.emailAutoresponder,
      emailRecipients: this.settings.emailRecipients,
    })
  }

  public async setMiscellaneousSettings() {
    this.setGlobalSettings({
      hideAdmin: this.hideAdmin,
      css: this.settings.css,
      xcss: this.settings.xcss,
      externalAccess: this.settings.externalAccess,
      therapistType: this.settings.therapistType,
    })
  }

  public async setGlobalSettings(settings: GlobalSettings) {
    this.callInProgress = true
    try {
      await Api.setGlobalSettings(settings)
      this.callInProgress = false
      Notify.create({
        type: 'success',
        title: 'Saved!',
        text: 'Website Global Settings Saved.',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async setGoogleTags() {
    this.setGlobalSettings({
      metaTag: this.settings.metaTag,
      gaCode: this.settings.gaCode,
      gaConversionTrackingCode: this.settings.gaConversionTrackingCode,
      googleTagManagerCode: this.settings.googleTagManagerCode,
    })
  }

  public updateContent(content) {
    this.settings.heading = content
  }

  public updateContactAddress(content) {
    this.settings.contactAddress = content
  }

  public async fetchDoaminImages() {
    this.callInProgress = true
    try {
      const domainImagesResponse = await Api.getDomainImages()
      this.domainImages = domainImagesResponse.domainImages
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public changeItem(event) {
    console.log(event.target.value)
    this.ogImageSelected = (event.target.value !== '')
    this.settings.ogImage = event.target.value
  }
}

